import type { IconProps } from "./types";

export function Check({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
      ? color
      : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.2636 0.263592C16.6151 -0.0878564 17.1856 -0.0878718 17.537 0.263592C17.8884 0.615066 17.8885 1.18559 17.537 1.53703L6.53704 12.537C6.18561 12.8885 5.61509 12.8884 5.2636 12.537L0.263604 7.53703C-0.087868 7.18556 -0.087868 6.61506 0.263604 6.26359C0.615078 5.91214 1.18558 5.91213 1.53704 6.26359L5.90032 10.6269L16.2636 0.263592Z"
        fill={currentColor}
        transform="translate(3.1 5.1)"
      />
    </svg>
  );
}
